/**
 * Moving one slide. Out-of-range asks are refused rather than clamped: the first slide
 * asked to move earlier stays where it is, which is what both the keyboard control and
 * a dropped drag mean by it.
 */
export function moveItem<T>(items: readonly T[], from: number, to: number): readonly T[] {
  if (from < 0 || from >= items.length) return items;
  if (to < 0 || to >= items.length) return items;
  if (from === to) return items;
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved as T);
  return next;
}
